<template>
  <div v-show="$store.getters.getShowPage"  id="app" v-if="userInfo.state !== undefined" :style="{paddingBottom: $route.meta.level === 1 ? '1.2rem' : ''}">
    <!--缓存页面-->
    <!--调用this.$store.commit('refresh')可刷新当前页面-->
    <!--通过设置meta.fromRouterkeepAlive实现前进刷新后退不刷新-->
    <keep-alive v-for="(route, index) in keepAliveRoutes" :key="index" v-if="$route.name !== route.name || !isRefresh">
      <router-view  v-if="$route.meta.keepAlive && $route.name === route.name"></router-view>
    </keep-alive>
    <!--不缓存页面-->
    <router-view v-if="!$route.meta.keepAlive && !isRefresh"></router-view>

    <myFooter></myFooter>

    <!-- <img src="@/images/certification/customer.png" style="width: 25px;height:auto;position:fixed;bottom:5rem;right:1rem;" @click="toIm"> -->

  </div>
</template>

<script type="text/ecmascript-6">

import myFooter from './components/common/my-footer'
import swalAlert from '../src/utils/swalAlert'
import axios from 'axios'
export default {
  name: 'App',
  components: {
    myFooter
  },
  data () {
    return {}
  },
  watch: {
    '$store.getters.isLoading' (val) {
      val ? this.$toast.loading({
        message: this.$store.getters.loadingText,
        duration: 0,
        forbidClick: true,
        closeOnClick: true
      }) : this.$toast.clear()
    }
  },
  computed: {
    isLoading () {
      return this.$store.getters.isLoading
    },
    isRefresh () {
      return this.$store.getters.isRefresh
    },
    keepAliveRoutes () {
      let list = []
      this.$router.options.routes.forEach((route) => {
        if (route.meta && route.meta.keepAlive) {
          list.push(route)
        }
      })
      return list
    }
  },
  methods: {
    // 新联系客服
    toIm () {
      const bussinessId = this.merchantInfo.im_id
      const visiterName = this.userInfo.nickname || this.userInfo.mobile || '游客'
      const visiterId = this.userInfo.id

      const headimgurl = this.userInfo.headimgurl ? this.userInfo.headimgurl : ''
      let url = 'https://comm.facaifacai.cn/index/index/home?theme=883bdf&visiter_id=' + visiterId + '&visiter_name=' + visiterName + '&avatar=' + headimgurl + '&business_id=' + bussinessId + '&groupid=0'
      location.href = url
    },
    getUrlKey: function (name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    },

    getAuthLink () {
      let merchantId = this.getUrlKey('state')
      if (!merchantId) {
        swalAlert.alertNormalStyle()
      } else {
        let inviteOpenId = this.getUrlKey('invite_openid')
        let code = this.getUrlKey('code')
        this.$http.post('mapi/Authorization/getAuthLink', {merchant_id: merchantId, invite_openid: inviteOpenId, code}).then(res => {
          window.location.replace(res.data)
        })
      }
    },
    async checkTokenForWechat () {
      try {
        const res = await this.$http.post('mapi/Check/checkTokenForWechat', {token: this.getUrlKey('token')})

        if (res.data) {
          this.updateUserInfo()
          this.getQiNiuYunToken()
        }
      } catch (error) {
        console.log(error)
      }
    },
    checkOwn () {
      // if (!this.isWechat) {
      //   // 保存进去缓存
      //   let loginExpire = this.$cookie.get('LOGIN_EXPIRE')
      //   if (!loginExpire) {
      //     this.$router.push({name: 'login', query: {token: this.token_}})
      //   } else {
      //     if (+new Date() < parseInt(loginExpire)) {
      //       // this.$router.push({name: 'home', query: {token: this.token_}})
      //       this.$router.push({name: 'home'})
      //     } else {
      //       this.$router.push({name: 'login', query: {token: this.token_}})
      //     }
      //   }
      // } else {
      // 通过微信自主认证
      // let IS_AUTO = this.getUrlKey('is_auto') || ''
      // if (!IS_AUTO) {
      //   let safe = this.getUrlKey('safe') || ''
      //   if (!safe) {
      //     this.checkTokenForWechat()
      //   }
      // }
      this.checkTokenForWechat()
      // this.$router.push({name: 'home', query: {token: this.token_}})
      // }
    }
  },
  async created () {
    // localStorage.setItem('token',
    //   '95_CySHnNY7AP6f0ufIVCcZR9862VoJqk2rfrviJgrhQUVC_0I8RY29ermm7391M5k10_MxnHB5SptP8LOOZTr56KdCmK1qdOqKL6AE1RcZJv8')
    // this.updateUserInfo()
    // this.getQiNiuYunToken()

    try {
      let token = this.getUrlKey('token')
      if (!token || token === 'none') {
        token = localStorage.getItem('token') || ''
      }

      if (!token) {
        this.getAuthLink()
      } else {
        localStorage.setItem('token', token)
        this.$store.commit('saveToken', token)
        axios.defaults.headers['token'] = token
        // this.checkOwn()
        await this.checkTokenForWechat()
      }
    } catch (error) {
      console.log(error)
    }
  }
}
</script>
<style scoped lang="less" rel="stylesheet/less">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  color: #565656;
  background-color: #EEEEEE;
  font-size: 0.8rem;
  min-height: 100vh;
  min-width: 100vw;
  line-height: 1.5;
  box-sizing: border-box;
}
.ellipsis{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space:nowrap
}

</style>



// WEBPACK FOOTER //
// src/App.vue